exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3hASHHFVj8M5o-OvECqC8h{width:16px;height:3px;position:absolute;top:23px;z-index:1}html[dir=ltr] ._3hASHHFVj8M5o-OvECqC8h{left:9px}html[dir=rtl] ._3hASHHFVj8M5o-OvECqC8h{right:9px}", ""]);
// Exports
exports.locals = {
	"colorHint": "_3hASHHFVj8M5o-OvECqC8h"
};